<app-loading-spinner [show]="loading"></app-loading-spinner>

<div class="row">
  <div class="col">
    <h2>Applicant Information</h2>
  </div>
</div>

<form [formGroup]="applicantFormGroup">
  <div class="row">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="mb-3">
        <label class="form-label" for="location">
          Which location are you planning on shopping?
          <span class="color-error">*</span>
        </label>
        <select id="location" class="form-select" aria-label="Location shopping at dropdown menu."
          formControlName="DomainID">
          <option selected value="">Select a location.</option>
          <option *ngFor="let item of locations" [value]="item.Value">
            {{ item.Text }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <app-request-purpose-info [controls]="applicantFormGroup.controls"
    label="What are you shopping for?"></app-request-purpose-info>

  <hr class="hr-style" />

  <app-applicant-info [controls]="applicantFormGroup.controls"></app-applicant-info>

  <app-contact-info [controls]="applicantFormGroup.controls"></app-contact-info>

  <hr class="hr-style" />

  <app-address-info [controls]="applicantFormGroup.controls"></app-address-info>

  <div class="row">
    <div class="col-12 col-md-12 col-lg-4">
      <app-living-situation-info [controls]="applicantFormGroup.controls"></app-living-situation-info>
    </div>
    <div class="col-12 col-md-12 col-lg-4">
      <app-employment-status-info [controls]="applicantFormGroup.controls"
        (changeEvent)="onEmploymentStatusChange($event)"></app-employment-status-info>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p>How long have you lived at your current address?</p>

      <app-address-time-info [controls]="applicantFormGroup.controls"></app-address-time-info>
    </div>
  </div>

  <hr class="hr-style" />

  <app-agreement-info [controls]="applicantFormGroup.controls" [isConsumerLoanApplication]="false"></app-agreement-info>
</form>

<hr class="hr-style" />

<div class="row my-5">
  <div class="col-12 col-md-6">
    <button [disabled]="loading || isSaving" type="button" class="btn btn-primary" (click)="onNext()">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      <span>Continue to Finish &amp; Submit</span>
      <i class="bi bi-chevron-right"></i>
    </button>

    <app-validation-text [show]="isDirtyAndMissingRequiredFields"></app-validation-text>
  </div>
  <div class="col-12 col-md-6">
    <div class="mt-3 mt-sm-0 text-center text-md-end">
      <button [disabled]="loading || isSaving" class="btn btn-link" (click)="onClearApplication()">
        <small> Clear Application </small>
      </button>
    </div>
  </div>
</div>